<template>
  <v-app id="inspire" class="grey lighten-3" >
    <UserNavbar/>
      <v-container
      id="abstract"
      fluid
      container
      class="py-0 fill-height">
      <v-row
        style=" text-align: center; justify-content: center; align-items: center; "
        align="center"
        justify="center">
        <!-- <p class="font-weight-bold text-h4">404</p><br> -->
          <v-col
            cols="12"
            class="d-flex flex-column align-center text-center"
          >
         <!-- <svg style="height: 60px; width: 60px; fill: #FF9B51;" xmlns="http://www.w3.org/2000/svg" id="Layer_1" data-name="Layer 1" viewBox="0 0 24 24">
          <path d="m3,5.5c0-.828.672-1.5,1.5-1.5s1.5.672,1.5,1.5-.672,1.5-1.5,1.5-1.5-.672-1.5-1.5Zm5.5,1.5c.828,0,1.5-.672,1.5-1.5s-.672-1.5-1.5-1.5-1.5.672-1.5,1.5.672,1.5,1.5,1.5Zm15.5-1v12c0,2.757-2.243,5-5,5H5c-2.757,0-5-2.243-5-5V6C0,3.243,2.243,1,5,1h14c2.757,0,5,2.243,5,5Zm-22,0v2h20v-2c0-1.654-1.346-3-3-3H5c-1.654,0-3,1.346-3,3Zm12,4H2v4.5h12v-4.5Zm-9,11h9v-4.5H2v1.5c0,1.654,1.346,3,3,3Zm17-3v-8h-6v11h3c1.654,0,3-1.346,3-3Z"/>
        </svg> -->
        <p class="font-weight-bold text-h5 primary-text" style="color: #25343F;">Page Not Found</p>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import UserNavbar from '@/components/PublicNavbar'

export default {
  data: () => {
    return {
      snackbar: false,
      crumbItems: [
        {
          text: 'Categories',
          disabled: false,
          href: '#',
          route: '/'
        }
      ],
      headers: [ { text: 'Report Name', value: 'name' },
        { text: 'Author', value: 'report_by' },
        { text: 'Date Created', value: 'date_created' },
        { text: 'Report Type', value: 'type' }
      ]
    }
  },
  components: {
    UserNavbar
  },
  mounted () {
    this.showSnackbar()
  },
  methods: {
    showSnackbar () {
      setTimeout(() => {
        this.snackbar = true
      }, 1000 * 20)
    },
    move () {
      this.$router.push('/login')
    },
    breadCrumbClick (item) {
      this.$router.push(item.route).catch(() => {
        window.location.reload()
      })
    }
  }
}
</script>

<style scoped>
#crumbs{
  align-content: right;
  justify-content: right;
}

#abstract{
  background-size: cover;
  background: url("../assets/404.svg");
  /* background: url("../assets/cccoil.svg"); */
  /* background: url("../assets/wave.svg"); */
  background-repeat: no-repeat;
  background-position: center;
  /* width: 100%; */
}
</style>
